import React, {Component} from 'react';
import {TASK_ACTIONS, DETAILS_VIEW_TYPE} from 'utils/constants';
import {connect} from 'react-redux';
import {taskAction} from '../mytasks/action/taskAction.action';
import {navigateBetweenHistoryTasks} from '../mytasks/action/navigateBetweenTasks.action';
import {
    getHistoryTasksForRender,
    getTaskDetails,
    getTaskAttachments,
    getAttachmentsLoadingStatus
} from '../store/application.reducers';
import {TaskDetailActions} from '../mytasks/AvailableActions.class';
import {pageLoaded} from '../router/route.action';
import {
    getHistoryTaskDetails,
    handleAddProcessAndHistoryComments,
    getTaskCommentsData,
    handleAddProcessAndHistoryDraftComments,
    getProcessAndHistoryComments, getProcessByUID,
} from "../taskdetails-remake/taskDetails.action";
import {formatTaskDetailsTopBanner} from 'utils/valueFormatter.function';
import {handleNPKeyNavigation} from 'utils/keyPressHandler.function';
import {preventDataReload} from '../myhistory/myHistory.action';
import _ from 'lodash';
import TaskDetails from 'components/taskdetails-remake/TaskDetails.component';
import {PATH_TO_MY_HISTORY} from "components/router/paths.js";
import { launchDarkly } from "utils/launchDarkly";


const cl = class TaskDetailMasterLayer extends Component {
    constructor(props) {
        super(props);

        this.getActionsForTask = this.getActionsForTask.bind(this);
        this.getTaskDetailFromStore = this.getTaskDetailFromStore.bind(this);
        this.requestData = this.requestData.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.getNavigation = this.getNavigation.bind(this);
        this.navigateBack = this.navigateBack.bind(this);
        this.navigateBetweenTasks = this.navigateBetweenTasks.bind(this);
        this.useDraftComments = launchDarkly.userClient && launchDarkly.userClient.variation("fe-draft-comments", false);
    }

    /*
     * default view is the attachemnts page so we need to get the attachemnts first
     * */
    componentDidMount() {
        // detail of current task is also in the store (use #getTaskDetailFromStore), but without for example the attachments, so we have to load it again

        this.requestData(this.props.match.params.taskId);
        document.addEventListener('keydown', this.handleKeyPress);
    }

    //this is needed to reload data at navigate between tasks with ctrl+alt+n
    componentDidUpdate(prevProps) {
        if (prevProps.match.params.taskId !== this.props.match.params.taskId) {
            this.requestData(this.props.match.params.taskId);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress);
    }

    navigateBetweenTasks(taskId, isForward) {
        this.props.history(this.props.navigateBetweenHistoryTasks(taskId, isForward));
    }


    handleKeyPress(e) {
        handleNPKeyNavigation(e, this.props.match.params.taskId, this.navigateBetweenTasks);
    }

    requestData(taskId) {
        this.props.getHistoryTaskDetails(taskId);
    }


    getTaskDetailFromStore() {
        const thisTaskArray = (this.props.tasks.allTasks || []).filter(task => {
            return task.key === this.props.match.params.taskId
        });
        return thisTaskArray[0];
    }

    getActionsForTask(navigation) {
        let activeActions = new TaskDetailActions();

        // add email
        activeActions.enable(TASK_ACTIONS.EMAIL);

        //check if move actions are available
        if (navigation.currentTask !== navigation.total) {
            //enable move to next
            activeActions.enable(TASK_ACTIONS.NEXT_TASK);
        }
        if (navigation.currentTask !== 1) {
            activeActions.enable(TASK_ACTIONS.PREVIOUS_TASK);
        }
        return activeActions;
    }

    getNavigation(task) {
        //fill in all the data found in the task
        let response = formatTaskDetailsTopBanner(task, true);
        if (task) {
            response.companyName = task.companyName;
            //task number and number of selected tasks still need to be computed
            response.currentTask = _.findIndex(this.props.tasks.allTasks, (x => {
                return x.key === task.key;
            })) + 1;
        }
        response.total = this.props.tasks.allTasks.length;
        //response.isProcess = true;
        return response;
    }


    navigateBack() {
        this.props.preventDataReload(true);
    }


    render() {
        const task = this.getTaskDetailFromStore();

        if (!task) {
            return <div>
                <span className="appicon loading"/>
            </div>;
        }

        let navigation = this.getNavigation(task);
        const activeActions = this.getActionsForTask(navigation);
        let params = {
            taskId: this.props.match.params.taskId
        }

        return (
            <TaskDetails params={params}
                         task={task}
                         taskAction={this.props.taskAction}
                         attachments={this.props.attachments}
                         loadingStatus={this.props.loadingStatus}
                         taskDetails={this.props.taskDetails}
                         navigation={navigation}
                         route={this.props.route}
                         navigateBetweenTasks={this.props.navigateBetweenHistoryTasks}
                         activeActions={activeActions}
                         navigateBack={this.navigateBack}
                         isHistory={true}
                         navigateBackPath={PATH_TO_MY_HISTORY}
                         routerBlocker={this.props.blocker}
                         type={DETAILS_VIEW_TYPE.HISTORY_TASK}
                         allowActionlessComments = {this.props.taskDetails.allowExtraComments}
                         addCommentHandler={this.useDraftComments ? this.props.handleAddProcessAndHistoryDraftComments : this.props.handleAddProcessAndHistoryComments}
                         getCommentsHandler={this.useDraftComments ? this.props.getProcessAndHistoryComments : this.props.getTaskCommentsData}
            />
        );
    }
}

const mapStateToProps = function (store) {
    return {
        tasks: getHistoryTasksForRender(store),
        taskDetails: getTaskDetails(store),
        attachments: getTaskAttachments(store),
        loadingStatus: getAttachmentsLoadingStatus(store)
    };
};

const connected = connect(mapStateToProps, {
    taskAction,
    preventDataReload,
    navigateBetweenHistoryTasks,
    pageLoaded,
    getHistoryTaskDetails,
    getProcessByUID,
    handleAddProcessAndHistoryComments,
    handleAddProcessAndHistoryDraftComments,
    getTaskCommentsData,
    getProcessAndHistoryComments,
})(cl);

export default connected;
